import React, { useEffect, useState } from 'react';
import Loader from '../../../components/Loader';
import { useNavigate, Link } from 'react-router-dom';
import Button from '../../../components/Button';
import { Range, getTrackBackground } from 'react-range';
import { fetchAllLocations } from '../../../api/common';
import ill_girl_iron from '../../../images/ill-girl-iron.png';
import PortalButton from '../../../components/Button';
const STEP = 10;
const MIN = 0;
const MAX = 100;
export default function JobFilter({ item }) {
  let navigate = useNavigate();
  const completeapp = () => {
    navigate(`/progress/`);
  };
  const [locations, setlocations] = useState([]);
  const [range, setrange] = useState([10]);
  const [loader, setloader] = useState(false);
  const getAllData = async () => {
    setloader(true);
    const res = await fetchAllLocations();
    setlocations(res);
    setloader(false);
  };
  useEffect(() => {
    getAllData();
  }, []);

  return (
    <div className="p-6 mt-5 shadow-lg rounded-sm">
      <header className="pb-2 relative">
        <h1 className=" text-2xl text-portal-600 font-semibold">Filters</h1>
      </header>
      <div className="flex flex-row justify-start gap-1">
        <div className="relative w-full">
          <label htmlFor="action-search" className="sr-only">
            Search
          </label>
          <input
            id="action-search"
            className="form-input focus:border-slate-300 w-full rounded-lg"
            type="search"
            placeholder="Enter your address or zip code"
          />
          <button className="absolute inset-0 left-auto group  bg-portal-100 m-1 rounded-lg" type="submit" aria-label="Search">
            <svg
              className="w-4 h-4 shrink-0 fill-current text-portalother-100 group-hover:text-slate-500 ml-3 mr-2"
              viewBox="0 0 16 16"
              xmlns="http://www.w3.org/2000/svg">
              <path d="M7 14c-3.86 0-7-3.14-7-7s3.14-7 7-7 7 3.14 7 7-3.14 7-7 7zM7 2C4.243 2 2 4.243 2 7s2.243 5 5 5 5-2.243 5-5-2.243-5-5-5z" />
              <path d="M15.707 14.293L13.314 11.9a8.019 8.019 0 01-1.414 1.414l2.393 2.393a.997.997 0 001.414 0 .999.999 0 000-1.414z" />
            </svg>
          </button>
        </div>
        <div className="relative inline-flex">
          <button
            className="btn bg-portal-100 text-portalother-100 py-1 px-2 rounded-lg cursor-pointer"
            onClick={() => onSingleItemClick('filter')}
            aria-haspopup="true">
            <span className="sr-only">Filter</span>
            <wbr />
            <svg
              xmlns="http://www.w3.org/2000/svg"
              className="h-6 w-6"
              fill="none"
              viewBox="0 0 24 24"
              stroke="currentColor"
              strokeWidth={2}>
              <path strokeLinecap="round" strokeLinejoin="round" d="M6 18L18 6M6 6l12 12" />
            </svg>
          </button>
        </div>
      </div>
      <div className="mt-6">
        <h1 className="my-4 text-lg text-portal-600 font-normal">Filter by location</h1>
        <div className="space-y-6 text-gray-800 text-base">
          <p>{item && item.description.replace(/\n/g, '<br>')}</p>
        </div>
      </div>
      {!loader ? (
        <div className="grid gap-5 md:grid-cols-2">
          {locations?.map((item, index) => (
            <div key={index} className="bg-portal-100 rounded-lg">
              <div className="m-3">
                <h2 className="text-sm leading-snug text-portalother-800 font-semibold my-3">{`${item.area}, ${item.state}`}</h2>
                {item?.locations.map((elm, idx) => (
                  <label className="flex items-center my-3" key={idx}>
                    <input type="checkbox" className="form-checkbox border-2 border-blue-400" />
                    <span className="text-sm ml-2 font-normal text-portal-500">{elm}</span>
                  </label>
                ))}
              </div>
            </div>
          ))}
        </div>
      ) : (
        <Loader />
      )}
      <div>
        <div className="flex items-center">
          <h1 className="my-4 text-lg text-portal-600 font-normal">Distance from Location</h1>
          <span className="text-sm font-medium whitespace-nowrap text-slate-500 ml-2">{item && item.region}</span>
        </div>
      </div>
      <div className="mb-10">
        <Range
          values={range}
          step={STEP}
          min={MIN}
          max={MAX}
          onChange={(values) => setrange(values)}
          renderMark={({ props, index }) => (
            <div
              {...props}
              style={{
                ...props.style,
                height: '20px',
                width: '1.5px',
                top: '26px',
                backgroundColor: index * STEP < range[0] ? '#548ff7' : '#ccc',
              }}
            />
          )}
          renderTrack={({ props, children }) => (
            <div
              onMouseDown={props.onMouseDown}
              onTouchStart={props.onTouchStart}
              style={{
                ...props.style,
                height: '36px',
                display: 'flex',
                width: '100%',
              }}>
              <div
                ref={props.ref}
                style={{
                  height: '3px',
                  width: '100%',
                  borderRadius: '4px',
                  background: getTrackBackground({
                    values: range,
                    colors: ['#548BF4', '#ccc'],
                    min: MIN,
                    max: MAX,
                  }),
                  alignSelf: 'center',
                }}>
                {children}
              </div>
            </div>
          )}
          renderThumb={({ props, isDragged }) => (
            <div
              {...props}
              style={{
                ...props.style,
                height: '20px',
                width: '20px',
                borderRadius: '20px',
                backgroundColor: '#548ff7',
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
              }}>
              <div
                style={{
                  height: '10px',
                  width: '10px',
                  borderRadius: '10px',
                  backgroundColor: isDragged ? '#fff' : '#fff',
                }}
              />
            </div>
          )}
        />
        <p className="text-center font-semibold pt-3">
          <output style={{ marginTop: '24px' }}>{range[0].toFixed(1)} mi</output>
        </p>
      </div>

      <div className="flex my-4">
        <div className="w-full md:w-1/3 pr-3">
          <PortalButton
            classes="w-full"
            variant="primary"
            text="Apply"
            onClick={(e) => {
              e.stopPropagation();
              completeapp();
            }}
          />
        </div>
        <div className="w-full md:w-1/3 pr-3">
          <PortalButton classes="w-full" variant="secondary" text="Clear" />
        </div>
      </div>
    </div>
  );
}
